/**
 * @module KUP
 */
(function ($) {

    'use strict';

    if (typeof KUP === 'undefined') {
        return null;
    }

    /**
     * ScrollToTop module
     *
     * @class KUP.ScrollToTop
     */
    var ScrollToTop = (function() {

            /**
             * Reference on the container id
             *
             * @private
             * @property container
             * @type {String}
             */
        var container = '#scroll-to-top',

            /**
             * css class for visibility from button
             *
             * @private
             * @property visibleClass
             * @type {String}
             * @default 'is-visible'
             */
            visibleClass = 'is-visible';

        /**
         * Initialization of the module
         *
         * @method init
         *
         */
        function init() {
            container = $(container);
            if ( container.length ) {
                initListener();
            }
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {
            // initial call 
            toggleButton();

            $(window).scroll(function () {
                toggleButton();
            });

            container.click(function () {
                $('html, body').animate({
                    scrollTop: 0
                }, '500');
            });
        }

        /**
         * Toggle Button initial and on scroll
         *
         * @private
         * @method toggleButton
         */
        function toggleButton() {
            if (window.pageYOffset > 320) {
                container.addClass(visibleClass);
            } else {
                container.removeClass(visibleClass);
            }
        }

        /**
         * @return Public-API
         */
        return {
            init : init
        };

    }());

    /**
     *
     * @for KUP
     * @property ScrollToTop
     * @type {Function}
     */
    KUP.ScrollToTop = ScrollToTop;

    return ScrollToTop;

}(jQuery));
